import { useIntl } from 'react-intl';

import { Adg4Button } from '@/components/adg4/button/src/button';

import { useAccountSigninContext } from '../hooks/account-signin-context';

export const Submit = ({ buttonText }: { buttonText?: string }) => {
	const intl = useIntl();

	const { isSubmitting, formError, onClickSubmitButton } = useAccountSigninContext();

	if (buttonText === undefined) {
		buttonText = intl.formatMessage({
			id: 'gwp.accountSignin.submit',
			defaultMessage: 'Log in',
		});
	}

	return (
		<Adg4Button
			type="submit"
			isDisabled={isSubmitting || formError}
			isFullWidth={true}
			isLoading={isSubmitting || formError}
			onClick={onClickSubmitButton}
		>
			{buttonText}
		</Adg4Button>
	);
};
